import { makeAutoObservable } from 'mobx';
import { ICredentialsStore } from '../../integration-store';
import {IKExpressCredentialsModel} from '../../../../../../models/IntegrationsTypes';

class KExpressCredentialsStore implements ICredentialsStore {
    private _changes: IKExpressCredentialsModel = {} as IKExpressCredentialsModel;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }
    public get apiToken() { return this._changes.api_token; };
    public get customerId() { return this._changes.customer_id; };

    setApiToken(value: string) {
        this._changes.api_token = value;
    };

    setCustomerId(value: string) {
        this._changes.customer_id = value;
    };

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }
}

export default KExpressCredentialsStore;